import mutations from './mutations';
import actions from './actions';
import { AdyenSession } from '@store/checkout/interfaces/adyenSession';
import { AdyenConfig } from "@store/checkout/interfaces/adyenConfig";

export interface PaymentState {
    adyenSession: AdyenSession,
    config: AdyenConfig
}

export const enum AdyenErrorCode {
  NETWORK_ERROR = 'NETWORK_ERROR',
  CANCEL = 'CANCEL',
  IMPLEMENTATION_ERROR = 'IMPLEMENTATION_ERROR',
  ERROR = 'ERROR',
}

export const enum AdyenResultCode {
  AUTHORISED = 'Authorised',
  SUCCESS = 'Success',
  PENDING = 'Pending',
  RECEIVED = 'Received',
  REFUSED = 'Refused',
  ERROR = 'Error',
  CANCELLED = 'Cancelled'
}

export const initialPaymentState: PaymentState = {
    adyenSession: {
        mode: '',
        amount: {
            currency: '',
            value: 0
        },
        countryCode: '',
        expiresAt: '',
        id: '',
        merchantAccount: '',
        reference: '',
        returnUrl: '',
        sessionData: '',
        shopperEmail: '',
        shopperLocale: '',
        splitCardFundingSources: false,
        threeDSAuthenticationOnly: false
    },
    config: {
        clientKey: '',
        environment: '',
        adyenCompanyId: '',
        adyenMerchantName: '',
        googleMerchantId: ''
    }
}

export default {
    namespaced: false,
    state: initialPaymentState,
    mutations,
    actions
}
